import React from 'react';

import classNames from 'classnames';

import { useAppSelector } from 'store/hook';
import { SelectAdvancedFilterOptionType } from 'types/common';
import { CompanyType } from 'types/company';

import { useSettingsContext } from './SettingsContext';
import SelectAdvancedFilter from '../lib/SelectAdvancedFilter';

type Props = {
  setPage: (value: number) => void;
};

const CommunitiesListCompanyFilter = ({ setPage }: Props) => {
  const { companies } = useAppSelector((state) => state.global);
  const { companiesFilter, setCompaniesFilter } = useSettingsContext();

  const companyOptions = companies?.map((company: CompanyType) => ({
    label: company.name,
    value: company.id,
  }));

  const handleSelectCompany = (values: SelectAdvancedFilterOptionType[]) => {
    const selection = (values ?? []).map((item: SelectAdvancedFilterOptionType) => item.value);
    setCompaniesFilter(selection);
    setPage(1);
  };

  return (
    <SelectAdvancedFilter
      className={classNames({ active: companiesFilter && companiesFilter.length > 0 })}
      placeholder={'Company'}
      options={companyOptions}
      defaultValue={companiesFilter ?? []}
      onSelect={handleSelectCompany}
    />
  );
};

export default CommunitiesListCompanyFilter;
